import { defineComponent as _defineComponent } from 'vue'
import { ContainsLessThanPercentOfContent } from "@/models/NutritionLabels/ContainsLessThanPercentOfContent";
import {useTranslations} from "@/hooks/useTranslations";
import {computed, ref, watch} from "vue";
import {splitLanguages} from "@/models/NutritionLabels/v2/Helpers";
import {LabelLanguage} from "@/models/NutritionLabels/LabelLanguage";

type USContainsPercentOfFormProps = {
  value: ContainsLessThanPercentOfContent;
  language: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'vUSContainsPercentOfForm',
  props: {
    value: null,
    language: null
  },
  emits: ["update:value", "all-input"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: ContainsLessThanPercentOfContent;
  language: string;
};



const translations = useTranslations();

const model = ref(props.value);
const acceptableThresholds = [0.5, 1.0, 1.5, 2.0];

const languageHeaders = computed(() => {
  return splitLanguages(LabelLanguage[props.language])
    .map((x) => LabelLanguage[x]);
});

watch(model, (newValue) => emit("update:value", newValue), { deep: true });

return { __sfc: true,props, emit, translations, model, acceptableThresholds, languageHeaders }
}

})